import React from "react";
import { Box, Typography, Paper, Avatar, Container } from "@mui/material";
import { FaTools } from "react-icons/fa";

const MaintenancePage = () => {
  return (
    <Container maxWidth="sm" sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center" }}>
      <Paper
        elevation={6}
        sx={{
          p: { xs: 3, sm: 5 },
          mt: 8,
          textAlign: "center",
          borderRadius: 4,
          background: "linear-gradient(135deg, #f5faff 0%, #c3e0f7 100%)"
        }}
      >
        <Avatar
          src="/logo.png"
          alt="Company Logo"
          sx={{ width: 92, height: 92, mx: "auto", mb: 2, bgcolor: "white", border: "2px solid #1e293b" }}
          variant="rounded"
        />
        <Box sx={{ mb: 2 }}>
          <FaTools size={44} color="#57a1d8" style={{ marginBottom: -8 }} />
        </Box>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, letterSpacing: 1 }}>
          We'll be back soon!
        </Typography>
        <Typography variant="h6" sx={{ color: "text.secondary", mb: 2 }}>
          Our website is currently undergoing scheduled maintenance.
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          We’re working hard to make our site even better.  
          Thank you for your patience and understanding.<br /><br />
          <b>Brainstorm Visions Team</b>
        </Typography>
        <Typography variant="body2" sx={{ color: "primary.main", mt: 4 }}>
          Need to contact us? Email: <a href="mailto:info@brainstorm-visions.com" style={{ color: "#57a1d8" }}>info@brainstorm-visions.com</a>
        </Typography>
      </Paper>
    </Container>
  );
};

export default MaintenancePage;
